import { render, staticRenderFns } from "./PieCardDashboard.vue?vue&type=template&id=0ffa0394&"
import script from "./PieCardDashboard.vue?vue&type=script&lang=js&"
export * from "./PieCardDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports